<template>
  <div>
    <div class="row mb-2">
      <div class="col-auto mr-auto">
        <h3>{{ $t("navigation." + constants.ROUTE_CATEGORIES) }}</h3>
      </div>
      <div class="col-auto d-flex align-items-center">
        <v-icon
          name="regular/plus-square"
          class="actions-icon"
          :title="$t('navigation.' + constants.ROUTE_NEW_CATEGORY)"
          @click="$router.push({ name: constants.ROUTE_NEW_CATEGORY })"
        />
      </div>
    </div>

    <transition-group mode="out-in" name="move" tag="div" class="row">
      <CategoryCard
        v-for="(category, id) in categories"
        :key="category.created"
        :id="id"
        :category="category"
      ></CategoryCard>
      <NewItemCard :route="{ name: constants.ROUTE_NEW_CATEGORY }" key="new" />
    </transition-group>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import "vue-awesome/icons/regular/plus-square";
import * as constants from "./../../constants";
import CategoryCard from "./CategoryCard";
import NewItemCard from "./../NewItemCard";

export default {
  name: "CategoriesList",
  components: { CategoryCard, NewItemCard },
  data() {
    return {
      constants
    };
  },
  props: {
    forceReload: { type: Boolean, default: false }
  },
  computed: {
    ...mapGetters(["categories"])
  },
  methods: {
    ...mapActions(["fetchCategories"])
  },
  created() {
    // when route changes, component is recreated every time - do not fetch the data every time,
    // only when forced via route props - e.g. after creating new category
    // see https://router.vuejs.org/guide/essentials/passing-props.html#boolean-mode
    if (this.forceReload) {
      this.fetchCategories();
    }
  }
};
</script>

<style scoped lang="scss"></style>
